import { z } from 'zod'

export const paramsSchema = z.object({
  emailAddress: z.string(),
  password: z.string(),
})

export type paramsType = z.infer<typeof paramsSchema>
